type InfoRowProps = {
  label: string;
  value: string;
};

export function InfoRow({ label, value }: InfoRowProps) {
  /* Modified by: Ishan | Soft-contrast detail info row */
  return (
    <div className="flex items-center justify-between gap-5 border-t border-[#F3F1FA] py-[13px] first:border-t-0">
      <dt className="shrink-0 text-[14px] font-normal text-[#6A6688]">{label}</dt>
      <dd className="min-w-0 text-right text-[14px] font-bold break-words text-[#3A3660]">
        {value}
      </dd>
    </div>
  );
}
